<template>
    <div>
        <div class="title">
            <div class="text mb-0">Online Booking</div>
        </div>

        <loader-list v-if="isLoading" />
        <div v-else-if="isNoConfig">
            Couldn't get PetCare Configurations. Please reload this page or
            contact DaySmart Vet for support.
        </div>
        <div v-else>
            <!-- Allow Cancel Appointment -->
            <div>
                <div class="checkbox-title">
                    <div class="green-toggle custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="appointment.type"
                            v-model="appointment.settings.cancel_appt"
                            :value="appointment.settings.cancel_appt"
                            :disabled="appointment.disabled"
                            @change="updateOption(false)"
                        />
                        <label
                            class="custom-control-label"
                            :for="appointment.type"
                        >
                            <div class="title-2">
                                <div class="text">Allow Cancel Appointment</div>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="group-holder mb-3 col-7">
                    By default, clients cannot cancel appointments from PetCare
                    to prevent last-minute no-shows and lost revenue. Clinics
                    can enable client cancellations in the PetCare or Online
                    Booking settings. If enabled, a restriction can be set to
                    only allow cancellations when the appointment is more than a
                    specified number of hour(s) away.
                </div>

                <div
                    class="row"
                    v-if="appointment.settings.cancel_appt == true"
                >
                    <div class="title-3">
                        <label for="cancellation-hours"
                            >Prevent cancellations within hour(s):</label
                        >
                    </div>
                    <div class="col-sm-1">
                        <span id="cancellation-hours">
                            <input
                                v-model.number="apptHours"
                                class="form-control"
                                type="number"
                                step="1"
                                max="99"
                                min="1"
                                placeholder="Max: 99"
                                @input="checkDigit"
                                :class="{
                                    'border-danger': errorBorder
                                }"
                            />
                        </span>
                    </div>
                    <button
                        type="button"
                        class="btn px-4 update-button"
                        :disabled="btnDisabled"
                        @click="updateOption(true)"
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoaderList from "@/components/elements/loader-list";
import SettingPetcare from "@/services/setting/petcare";
import { find } from "lodash";

const APPOINTMENT = "appointment";

export default {
    components: {
        LoaderList
    },
    data() {
        return {
            isLoading: false,
            isNoConfig: true,
            btnDisabled: true,
            errorBorder: false,
            apptHours: 24,
            appointment: {
                type: "appointment",
                disabled: false,
                settings: {
                    cancel_appt: false,
                    cancel_appt_hours: 24
                }
            }
        };
    },
    mounted() {
        this.getConfig();
    },
    watch: {},
    methods: {
        getConfig() {
            this.isLoading = true;
            this.isNoConfig = false;
            let self = this;

            SettingPetcare.getDeliveryConfig()
                .then(response => {
                    let resource = response.resource;
                    if (
                        response.code === 200 &&
                        resource &&
                        resource.settings
                    ) {
                        let appointmentSettings = find(
                            resource.settings,
                            function (settings) {
                                return settings.type === APPOINTMENT;
                            }
                        );
                        if (appointmentSettings !== undefined) {
                            this.appointment.settings.cancel_appt =
                                appointmentSettings.data[0].cancel_appt;
                            this.apptHours =
                                appointmentSettings.data[0].cancel_appt_hours;
                        }
                    } else {
                        self._message(
                            "Error : Unable to get PetCare Configurations",
                            "danger"
                        );
                        self.isNoConfig = true;
                    }
                })
                .catch(error => {
                    console.error(error);
                    self._message(
                        "Error : Unable to get PetCare Configurations",
                        "danger"
                    );
                    self.isNoConfig = true;
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        updateOption(triggered) {
            let self = this;
            self.btnDisabled = true;
            let params = {
                type: APPOINTMENT,
                settings: self.appointment.settings
            };
            if (triggered) {
                self.appointment.settings.cancel_appt_hours = self.apptHours;
                params = {
                    type: APPOINTMENT,
                    settings: self.appointment.settings
                };
            } else {
                self.apptHours = 24;
                if (self.appointment.settings.cancel_appt === false) {
                    params = {
                        type: APPOINTMENT,
                        settings: {
                            cancel_appt: false,
                            cancel_appt_hours: 0
                        }
                    };
                } else {
                    params = {
                        type: APPOINTMENT,
                        settings: {
                            cancel_appt: true,
                            cancel_appt_hours: 24
                        }
                    };
                }
            }
            SettingPetcare.updateSetting(params)
                .then(response => {
                    if (response.code === 200) {
                        self._message("Successfully update configuration");
                    } else {
                        self._message(
                            "Error : Unable to update PetCare Configurations",
                            "danger"
                        );
                    }
                })
                .catch(error => {
                    self._message(
                        "Error : Unable to update PetCare Configurations",
                        "danger"
                    );
                    console.error(error);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        checkDigit(event) {
            const value = event.target.value;
            if (
                value === "" ||
                value.includes(".") ||
                isNaN(Number(value)) ||
                value < 1 ||
                this.apptHours > 99
            ) {
                this.btnDisabled = true;
                this.errorBorder = true;
            } else {
                this.btnDisabled = false;
                this.errorBorder = false;
            }
        }
    }
};
</script>

<style scoped>
.checkbox-title {
    margin-top: 40px;
}
.title-2 {
    font-weight: 800;
    font-size: 20px;
    margin-bottom: 5px;
}
.title-3 {
    font-weight: 600;
    font-size: 13px;
}
.row {
    align-items: flex-end;
    margin-left: 0px;
    margin-right: 0px;
}
.update-button {
    background-color: #180f29;
    color: white;
}
</style>
